import { Field } from "formik";
import React, { useState } from "react";
import * as yup from "yup";
import DefaultActionButtonGenerator, {
  ACTION_BUTTON_TYPES as ABT,
  pushToParams,
  requestTo,
} from "../../components/action-buttons/ActionButtonGenerator";
import { Accordion, Button, Card } from "react-bootstrap";
import Filters from "../../components/list/Filters";
import CrudMain from "../../components/crud/CrudMain";
import FormikForm from "../../components/crud/FormikForm";
import CurrencyInput from "../../components/form-fields/CurrencyInput";
import Select from "../../components/form-fields/Select";
import TextInput from "../../components/form-fields/TextInput";
import ListComponent from "../../components/list/ListComponent";
import Main from "../../components/main/Main";
import { useTranslation } from 'react-i18next';                   /* Added Line */
import Checkbox from "../../components/form-fields/Checkbox";

export default function DemandTypes() {
  const [showModal, setShowModal] = useState(false);
  const [configData, setConfigData] = useState(null);
  const [refreshList, setRefreshList] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [initialValues, setInitialValues] = useState({});
  const [selectedRow, setSelectedRow] = useState(null);
  const [t, i18n] = useTranslation();         /* Added Line */
  const [activeIndicatorInLeftPosition, setActiveIndicatorInLeftPosition] =
    useState("filter");
  const [filters, setFilters] = useState([]);
  const [statusCheckBoxValue, setStatusCheckBoxValue] = useState(false);
  const validationSchema = yup.object({});

  const arrangeBeforePersist = (values) => {
    let payload = {
      talepTuru: values.talepTuru,
      talepTuruTr: values.talepTuruTr,
      talepTuruEn: values.talepTuruEn,
      numaraDescr: values.numaraDescr,
      departmentId: values.departmentId,
      siraNo: values.siraNo,
      id: values.id,
      stId: values.stId || 90,
    };
    return payload;
  };

  const adaptDataForUpdate = (data) => {
    let adaptedData = {
      talepTuru: data.talepTuru,
      talepTuruTr: data.talepTuruTr,
      talepTuruEn: data.talepTuruEn,
      numaraDescr: data.numaraDescr,
      departmentId: data.departmentId,
      siraNo: data.siraNo,
      id: data.id,
      stId: data.stId,
    };
    setInitialValues(adaptedData);
  };

  const onUpdateButtonClicked = (selectedRow) => {
    setShowModal(true);
    setIsUpdating(true);
    setSelectedRow(selectedRow);
    const { stId } = selectedRow;
    if (stId === 90) setStatusCheckBoxValue(true);
    else setStatusCheckBoxValue(false);
  };

  const onAddButtonClicked = () => {
    setShowModal(true);
    setIsUpdating(false);
    setInitialValues({});
  };

  const linkFollow = (cell, row, rowIndex, formatExtraData) => {
    return (
        <Button className="btn-xs"
        onClick={() => {
          onUpdateButtonClicked(row);
        }}
      >
        <i className="fa fa-search color-white"></i>
      </Button>
    );
  };

  return (
    <Main>
      <div className={"row"}>
        <div className="col-md-12">
          <Accordion
            className="accordion accordion-rounded-stylish accordion-bordered"
            defaultActiveKey="filter"
          >
            <div className="accordion__item" key={"filter"}>
              <Accordion.Toggle
                as={Card.Text}
                eventKey={"filter"}
                className={`accordion__header ${
                  activeIndicatorInLeftPosition === "filter" ? "" : "collapsed"
                } accordion__header--primary`}
                onClick={() =>
                  setActiveIndicatorInLeftPosition(
                    activeIndicatorInLeftPosition === "filter" ? "" : "filter"
                  )
                }
              >
                <span className="accordion__header--icon"></span>
                <span className="accordion__header--text">
                  {t("sozlesmeler.filtreleme")}
                </span>
                <span className="accordion__header--indicator"></span>
              </Accordion.Toggle>
              <Accordion.Collapse
                eventKey={"filter"}
                className="accordion__body"
              >
                <div className="accordion__body--text">
                  <Filters
                    configPointUrl="talep-tur/config"
                    setConfigData={(data) => setConfigData(data)}
                    setRefreshList={setRefreshList}
                    refreshList={refreshList}
                    setFilters={setFilters}
                  >
                    <Field
                      name="departmentId"
                      label={t("documentTypes.departman")}
                      colNumber="3"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      oper="EQ"
                      options={configData && configData.department}
                    />
                    <Field
                      name="talepTuruTr"
                      label={t("demandTypes.talepTürüTr")}
                      colNumber="3"
                      component={TextInput}
                      oper="CONTAINS_CASE_AND_ACCENT_INSENSITIVE"
                    />
                    <Field
                      name="talepTuruEn"
                      label={t("demandTypes.talepTürüEn")}
                      colNumber="3"
                      component={TextInput}
                      onlyEnglish={true}
                      oper="CONTAINS_CASE_AND_ACCENT_INSENSITIVE"
                    />
                  </Filters>
                </div>
              </Accordion.Collapse>
            </div>
          </Accordion>
        </div>
      </div>
      <div className="row">
        <div className="col-xl-12 col-xxl-12">
          <CrudMain
            onAddButtonClicked={onAddButtonClicked}
            showModal={showModal}
            setShowModal={setShowModal}
            title={t("sidebar.talepTürleri")}
            hideNewAddButton
            unscrollable
          >
            <FormikForm
              isUpdating={isUpdating}
              entityId={selectedRow && selectedRow.id}
              entityFetchId="id"
              
              endPointUrl="talep-tur/create"
              fetchPointUrl="talep-tur/find"
              editPointUrl="talep-tur/update"
              configPointUrl="talep-tur/config"
              arrangeBeforePersist={arrangeBeforePersist}
              adaptDataForUpdate={adaptDataForUpdate}
              setConfigData={(data) => setConfigData(data)}
              initialValues={initialValues}
              validationSchema={validationSchema}
              closeModal={() => setShowModal(false)}
              refreshList={() => setRefreshList(!refreshList)}
            >
              <Field
                name="departmentId"
                label={t("demandTypes.departman")}
                colNumber="12"
                component={Select}
                options={configData && configData.department}
              />

              <Field
                name="talepTuruTr"
                label={t("demandTypes.talepTürüTr")}
                colNumber="12"
                component={TextInput}
              />
            <Field
                name="talepTuruEn"
                label={t("demandTypes.talepTürüEn")}
                colNumber="12"
                component={TextInput}
                onlyEnglish={true}
              />
              <Field
                name="siraNo"
                label={t("demandList.siraNo")}
                colNumber="12"
                component={TextInput}
              />
              <Field
                name="statusName"
                label={t("demandList.aktifDurum")}
                colNumber="12"
                component={Checkbox}
                value={statusCheckBoxValue}
                onChangeFunc={(checked) => {
                  let st = 90; 
                  if(!checked) st = 91; 
                  setInitialValues({...initialValues, stId: st}); 
                  setStatusCheckBoxValue(checked);
                }}
              />
              {/* <Field
                name="siraNo"
                label="Sıra No"
                colNumber="12"
                component={CurrencyInput}
              /> */}
            </FormikForm>
          </CrudMain>
        </div>
      </div>

      <div className="row">
        <div className="col-md-12">
          <ListComponent
            entityName="talep-türleri"
            endpoint="talep-tur/list"
            keyField="id"
            refreshList={refreshList}
            hideSelection={true}
            columns={[
              {
                dataField: "id",
                text: "ID",
                sort: true,
                headerClasses: "id-header",
              },
              {
                dataField: "departmentName",
                text: `${t("demandList.departmanAdi")}`,
                sort: true,
              },
              {
                dataField: "talepTuruTr",
                text: `${t("demandList.talepTuruTr")}`,
                sort: true,
              },
              {
                dataField: "talepTuruEn",
                text: `${t("demandList.talepTuruEn")}`,
                sort: true,
              },
              {
                dataField: "siraNo",
                text: `${t("demandList.siraNo")}`,
                sort: true,
              },
              {
                dataField: "statusName",
                text: `${t("demandList.durum")}`,
                sort: true,
              },
              {
                dataField: "",
                text: "İşlemler",
                formatter: linkFollow,
                sort: false,
              },
            ]}
            customBody={{
              filters: filters,
            }}
            actionButtonsObject={{
              actions: [
                pushToParams(ABT.EDIT, onUpdateButtonClicked),
                // requestTo(ABT.DELETE, "talep-tur/delete"),
              ],
              generator: DefaultActionButtonGenerator,
            }}
          />
        </div>
      </div>
    </Main>
  );
}
